export const nextOrSkip = (required, value, strings) => {
  if (value) return strings.next_btn
  if (required) {
    return strings.next_btn
  }
  return strings.skip
}

/**
 * Next-button label for a sibling (multi-question) page.
 * Mirrors nextOrSkip: all-optional groups show Skip; any required question shows Next.
 */
export const nextOrSkipSiblings = (
  webSurvey,
  submissionSurvey,
  siblingOrder,
  strings
) => {
  if (!Array.isArray(siblingOrder) || siblingOrder.length === 0) {
    return strings.next_btn
  }
  const anyRequired = siblingOrder.some((questionId) => {
    const q = webSurvey?.questions?.[questionId]
    return q?.attributes?.required
  })
  if (!anyRequired) {
    return strings.skip
  }
  return strings.next_btn
}

export const allowEnterPress = (required, content) => {
  if (!required) {
    return true
  }
  return !!content
}

export const removeExtraNewline = (html) => {
  return html.replace(/<br\/><br><br\/>/g, '<br/><br>')
}